module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/female-1-6e90cd9e472195e19efb9b542d210d75.jpg";